"use client";
import styled from "styled-components";
import { PageWrapper } from "./globalsStyles";

export const InfoPageWrap = styled(PageWrapper)`
  text-align: center;
  display: flex;
  flex-direction: column;
  /* gap: 2rem; */
  /* padding: 0 2rem; */
`;

export const GetToKnowWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
`;
